import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { TooltipProvider } from './components/ui/tooltip';
import { queryClient, trpc, trpcClient } from './lib/trpc';
import { AppRoutes } from './routes';

// trpc.Provider must wrap QueryClientProvider, and both must be above the
// router so any page can call useQuery / useMutation against the API.
// Toaster sits at the same level so toast() can fire from anywhere.
// TooltipProvider at the root so individual cards don't have to nest their
// own — delayDuration 300ms is responsive without firing on accidental hover.
export function App() {
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={300}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster />
        </TooltipProvider>
      </QueryClientProvider>
    </trpc.Provider>
  );
}
